<template functional>
  <table class="entsys--table payout-report-table">
    <colgroup>
      <col />
      <col />
      <col />
      <col />
      <col />
    </colgroup>
    <thead class="hidden-sm-and-down">
      <tr>
        <th class="text-left">
          {{
            parent.$t(
              "people:ShoppingBasket.Events.PersonEventFinancialReport.Payouts.time.label",
              "Time"
            )
          }}
        </th>
        <th class="text-left">
          {{
            parent.$t(
              "people:ShoppingBasket.Events.PersonEventFinancialReport.Payouts.referenceCode.label",
              "Reference"
            )
          }}
        </th>
        <th class="text-left">
          {{
            parent.$t(
              "people:ShoppingBasket.Events.PersonEventFinancialReport.Payouts.method.label",
              "Method"
            )
          }}
        </th>
        <th class="text-left">
          {{
            parent.$t(
              "people:ShoppingBasket.Events.PersonEventFinancialReport.Payouts.account.label",
              "Account"
            )
          }}
        </th>
        <th class="text-right">
          {{
            parent.$t(
              "people:ShoppingBasket.Events.PersonEventFinancialReport.Payouts.amount.label",
              "Amount"
            )
          }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="payout in props.confirmedPayouts" :key="payout.id">
        <td class="text-left">
          <div class="d-flex flex-row justify-space-between">
            <div class="hidden-md-and-up font-weight-bold">
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.Payouts.time.label",
                  "Time"
                )
              }}
            </div>
            <div class="text-right text-md-left">
              {{ parent.$dayjs.date(payout.confirmedAt, "fullTime") }}
            </div>
          </div>
        </td>
        <td class="text-left">
          {{ payout.referenceCode }}
        </td>
        <td class="text-left">
          <div class="d-flex flex-row justify-space-between">
            <div class="hidden-md-and-up font-weight-bold">
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.Payouts.method.label",
                  "Method"
                )
              }}
            </div>
            <div class="text-right text-md-left">
              {{ parent.$t("common:payment.processor." + payout.processor) }}
            </div>
          </div>
        </td>
        <td class="text-left">
          <div class="d-flex flex-row justify-space-between">
            <div class="hidden-md-and-up font-weight-bold">
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.Payouts.account.label",
                  "Account"
                )
              }}
            </div>
            <div class="text-right text-md-left">
              <template v-if="payout.recipientContact">
                {{ payout.recipientContact.iban }}
                {{ payout.recipientContact.name }}
              </template>
            </div>
          </div>
        </td>
        <td class="text-right">
          <div class="d-flex d-print-flex flex-row justify-space-between">
            <div class="hidden-md-and-up font-weight-bold">
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.Payouts.amount.label",
                  "Amount"
                )
              }}
            </div>
            <div class="text-rights">
              {{ parent.masterCurrency(payout.amountCents) }}
            </div>
          </div>
        </td>
      </tr>
      <tr class="total-summary">
        <td colspan="4" class="text-left text-md-right">
          <b>
            {{
              parent.$t(
                "people:ShoppingBasket.Events.PersonEventFinancialReport.Payouts.total.label",
                "Total received from organiser"
              )
            }}</b
          >
        </td>
        <td class="text-right">
          <b>{{ parent.masterCurrency(props.totals.totalReceivedCents) }}</b>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: "PersonStatementReportPayouts",
  props: {
    confirmedPayouts: {
      type: Array,
      required: true
    },
    totals: {
      type: Object,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
@use "mixin.scss" as c;
.payout-report-table {
  colgroup {
    col:last-child {
      width: 12%;
      @media (max-width: 960px) {
        width: auto;
      }
    }
  }
  tr {
    @include c.mobile-row;
  }
}
</style>
